

export const frontMatter = {
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	}
};
export const contentTitle = 'Клавіятуры';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-be-docusaurus-plugin-content-docs-current-resources-keyboards-md-153.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Windows",
  "id": "windows",
  "level": 2
}, {
  "value": "Mac",
  "id": "mac",
  "level": 2
}, {
  "value": "Linux і BSD",
  "id": "linux",
  "level": 2
}, {
  "value": "Android",
  "id": "android",
  "level": 2
}, {
  "value": "Іншыя платформы",
  "id": "other-platforms",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    p: "p",
    span: "span",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "клавіятуры",
        children: "Клавіятуры"
      })
    }), "\n", _jsx(_components.h2, {
      id: "windows",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Windows"
      })
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://tyflonet.com/siciliano/klaviatury",
        children: "http://tyflonet.com/siciliano/klaviatury"
      })
    }), "\n", _jsx(_components.h2, {
      id: "mac",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Mac"
      })
    }), "\n", _jsx(_components.p, {
      children: "TODO: дадаць спасылкі"
    }), "\n", _jsxs(_components.h2, {
      id: "linux",
      children: [_jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Linux"
      }), " і ", _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "BSD"
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Пашыраная MS Latin на міжнародных лацінскіх клавіятурах (напрыклад, ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "hrvatska"
        }), " ў варыянце ", _jsx(_components.span, {
          className: "notranslate",
          translate: "no",
          children: "unicodeus"
        }), ")."]
      }), "\n", _jsx(_components.li, {
        children: "Поўная кірылічная клавіятура на стандартнай украінскай клавіятуры."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "android",
      children: _jsx(_components.span, {
        className: "notranslate",
        translate: "no",
        children: "Android"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://usachov.eu/g",
        children: "http://usachov.eu/g"
      })
    }), "\n", _jsx(_components.h2, {
      id: "other-platforms",
      children: "Іншыя платформы"
    }), "\n", _jsx(_components.p, {
      children: "Калі для вашай платформы няма клавіятуры, вы можаце паспрабаваць выкарыстоўваць некаторыя ўбудаваныя раскладкі клавіятуры:"
    }), "\n", _jsxs(_components.p, {
      children: ["Для ", _jsx(_components.strong, {
        children: "міжславянскай лацініцы"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Чэшская (стандартная, часткова этымалагічная)"
      }), "\n", _jsx(_components.li, {
        children: "Харвацкая (з выключэннямі)"
      }), "\n", _jsx(_components.li, {
        children: "Сербская (з выключэннямі)"
      }), "\n", _jsx(_components.li, {
        children: "Славенская (з выключэннямі)"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Для ", _jsx(_components.strong, {
        children: "міжславянскай кірыліцы"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Сербская (з выключэннямі, без ", _jsx(_components.code, {
          children: "Ы"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

